module.exports = __webpack_public_path__ + "img/exchng_diagram.png";